/*** IMPORTS FROM imports-loader ***/
var global = window;

export { startSegmentCollection, setSegmentBytesLimit } from './segmentCollection';
export { SEGMENT_BYTES_LIMIT } from './segmentCollection';
//# sourceMappingURL=index.js.map
